import { render } from "./DownloadLimitModal.vue?vue&type=template&id=46bb32c8"
import script from "./DownloadLimitModal.vue?vue&type=script&lang=js"
export * from "./DownloadLimitModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__